import React, { useMemo } from 'react';
import Section from '@components/Section';
import { useSelector } from 'react-redux';
import { selectContactTimeline } from '@reducers/data/timeline';
import { SidebarTimelineInteraction } from '../Timeline/Interaction';
import Contact from '@models/Contact';
import { TimelineItem } from '@models/Timeline';

export default function SidebarTimeline({ contact }: { contact: Contact }) {
  const timeline = useSelector(selectContactTimeline(contact.id, true));
  const timelineItems = useMemo<TimelineItem[]>(() => {
    return timeline.items.valueSeq().toArray().slice(0, 4);
  }, [timeline]);

  if (timelineItems.length === 0) {
    return null;
  }

  return (
    <Section>
      <Section.Title underline>Timeline</Section.Title>
      <div>
        {timelineItems.map((item, idx, timeline) => {
          const isLast = idx === timeline.length - 1;
          return (
            <SidebarTimelineInteraction
              key={item.stableID}
              contact={contact}
              timelineItem={item}
              isLast={isLast}
            />
          );
        })}
      </div>
    </Section>
  );
}
